import { render } from "./userSelectModal.vue?vue&type=template&id=88f20826&scoped=true"
import script from "./userSelectModal.vue?vue&type=script&lang=js"
export * from "./userSelectModal.vue?vue&type=script&lang=js"

import "./userSelectModal.vue?vue&type=style&index=0&id=88f20826&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88f20826"]])

export default __exports__